export const OBM_TABLE_HEADER_TEXTS = {
    TITLE: "Campaigns' Groups",
    SUBTITLE: 'A deep dive view of every cluster.',
    PLACEHOLDER: 'Search',
    ADVANCED_SWITCH: 'Advanced Settings',
};
